const namespaced = true
import api from '../../api/location.js';

const state = {
    location: [],
    locations: [],
}
const mutations = {
    MUTATION_SET_locations(state, data) {
        state.locations = data;
    }
}
const actions = {
    getLocations(context) {
        return new Promise((resolve) => {
            api.getLocation().then(function (res) {
                context.commit('MUTATION_SET_locations', res.data);
                resolve(res.data);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });

            })
        })
    },
    store(context,data) {
        return new Promise((resolve) => {
            api.store(data).then(function (res) {
                context.commit('MUTATION_SET_locations', res.data);
                resolve(res.data);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });

            })
        })
    },
    update(context,obj) {
        return new Promise((resolve) => {
            api.update(obj.id, obj.data).then(function (res) {
                context.commit('MUTATION_SET_locations', res.data);
                resolve(res.data);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });

            })
        })
    },
}

const getters = {

}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}